import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { AccordionProvider, useAccordion } from '../../../store/Context/AccrodionContext';

interface AccodrionProps {
  children?: React.ReactNode;
  multi?: boolean;
}
export const Accordion = (props: AccodrionProps) => {
  const { children, multi } = props;
  return (
    <AccordionProvider multi={multi}>
      <div className='flex flex-col gap-4'>{children}</div>
    </AccordionProvider>
  );
};

interface IAccordionItemProps {
  id: string;
  title: React.ReactNode;
  children: React.ReactNode;
  customClassName?: string;
  rootClassName?: string;
  triggerClassName?: string;
}
export const AccordionItem = (props: IAccordionItemProps) => {
  const { id, title, children, customClassName, rootClassName, triggerClassName } = props;
  const { appendId, removeId, isActive } = useAccordion();
  const active = isActive(id);
  return (
    <div id={id} className={twMerge(['border rounded', rootClassName])}>
      <div
        role='button'
        tabIndex={0}
        className={twMerge(['px-3.5 py-4', active ? 'pb-2' : '', triggerClassName])}
        onClick={() => {
          if (active) {
            removeId(id);
          } else {
            appendId(id);
          }
        }}
      >
        <div className='flex gap-1 justify-between items-center w-full'>
          <div className='flex-grow'>{title}</div>
          {active ? (
            <ChevronUpIcon className='h-5 w-5 text-neutralColor-light' />
          ) : (
            <ChevronDownIcon className='h-5 w-5 text-neutralColor-light' />
          )}
        </div>
      </div>
      {active && (
        <div className={twMerge(['px-3.5 py-4 transition transition-height duration-500 ease-in-out', customClassName])}>{children}</div>
      )}
    </div>
  );
};

export const AccordionItemT2 = (props: IAccordionItemProps) => {
  const { id, title, children, customClassName } = props;
  const { appendId, removeId, isActive } = useAccordion();
  const active = isActive(id);

  useEffect(() => {
    appendId(id);
  }, [appendId, id]);

  return (
    <div id={id} className='border rounded'>
      <div tabIndex={0} className={`px-3.5 py-4 ${active ? 'pb-2' : ''}`}>
        <div className='flex gap-1 justify-between items-center w-full '>
          <div className='flex-grow'>{title}</div>
          {active ? (
            <ChevronUpIcon className='h-5 w-5 text-neutralColor-light cursor-pointer' onClick={() => removeId(id)} />
          ) : (
            <ChevronDownIcon className='h-5 w-5 text-neutralColor-light cursor-pointer' onClick={() => appendId(id)} />
          )}
        </div>
      </div>
      {active && <div className={twMerge(['px-3.5 py-4 transition duration-500 ease-in-out', customClassName])}>{children}</div>}
    </div>
  );
};
